import type { ItemTablero } from '@/core/services/tareasGrupoService'

/**
 * Devuelve los ids de las tareas de una columna en el orden que queda al mover el ítem de `desde` a `hasta`.
 * Los índices son de ítems del tablero. Un grupo aporta sus tareas del tablero en el orden en que se muestran.
 */
export const ordenTrasMover = (items: ItemTablero[], desde: number, hasta: number): string[] => {
  const movidos = [...items]
  const [item] = movidos.splice(desde, 1)
  if (!item) return []
  movidos.splice(hasta, 0, item)
  return movidos
    .flatMap((i) => (i.tipo === 'tarea' ? [i.tarea] : i.grupo.enTablero))
    .flatMap((t) => (t.id ? [t.id] : []))
}
